























































































































































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import TournamentChip from '@/modules/tournament/components/TournamentChip'
import AppButton from '@/modules/shared/components/AppButton'
import RegistrationProgress from '@/modules/instant/components/RegistrationProgress'
import { TournamentState } from '@/api/tournament'
import tournamentStore from '@/modules/tournament/tournament.store'
import { getModule } from 'vuex-module-decorators'
import { date } from '@/utils'
import { String } from 'lodash'
import InstantMatchActionButtons from '@/modules/instant/components/InstantMatchActionButtons'
import { RegionInfo } from '@/api/config'

@Component({
  components: {
    TournamentChip,
    AppButton,
    RegistrationProgress,
    InstantMatchActionButtons
  },
  filters: {
    date
  }
})
export default class InstantMatchTournamentBasicInformation extends Vue {
  @Prop({ required: true }) readonly tournamentId!: string
  @Prop({ required: true }) readonly name!: String
  @Prop({ required: true }) readonly game!: string
  @Prop({ required: true }) readonly regions!: RegionInfo[]
  @Prop({ required: true }) readonly registrationStartTime!: Date
  @Prop({ required: true }) readonly registrationEndTime!: Date
  @Prop({ required: true }) readonly startTime!: Date
  @Prop({ required: true }) readonly endTime!: Date
  @Prop({ required: true }) readonly prizePool!: string
  @Prop({ required: true }) readonly registeredTeams!: number
  @Prop({ required: true }) readonly maxTeams!: number
  @Prop({ required: true }) readonly minPlayersPerTeam!: number
  @Prop({ default: false }) readonly displayInfoOnHover!: boolean
  @Prop({ default: false }) readonly displayInfo!: boolean
  @Prop({ default: false }) readonly hideActionButton!: boolean
  @Prop({ default: false }) readonly isFeaturedTournament!: boolean
  @Prop({ default: false }) readonly hasEntryFee!: boolean
  @Prop({ default: '' }) readonly entryFee!: string
  @Prop({ default: TournamentState.Initial }) readonly state!: TournamentState
  @Prop({ default: 'max' }) readonly buttonSize!: string

  isTextVisible: boolean = false
  tournamentModule = getModule(tournamentStore, this.$store)

  /* Hooks */
  mounted() {
    setTimeout(() => {
      this.isTextVisible = true
    }, 100)
  }

  /* Computed Properties */
  get prizeComponents(): string[] {
    return this.prizePool.split(/([\d|,]+)/)
  }

  get isUserJoinedTournament() {
    return this.tournamentModule.joinedTournaments
      .map(tournament => tournament.tournamentId)
      .includes(this.tournamentId)
  }

  get shouldStatusButtonVisible() {
    if (this.hideActionButton) {
      return false
    }

    if (
      this.$route.name === 'Landing' ||
      this.$route.name === 'AutomatedTournament' ||
      this.state === TournamentState.OpenRegistration ||
      this.isUserJoinedTournament
    ) {
      return true
    }

    return false
  }

  get TournamentState() {
    return TournamentState
  }

  get remainingTeams() {
    return this.maxTeams - this.registeredTeams
  }

  /* Methods */
  getPrizeComponentClass(value: string) {
    if (/([\d|,]+)/.test(value)) return 'prize-number'
    else return 'prize-text'
  }

  onCheckPlayerListClicked() {
    this.tournamentModule.setAutomatedTournamentTeamListDialogVisible(true)
  }
}
